import React from "react";
import "../../SpearParts/Layouts/Layouts.css";

export const NewAbout = () => {
  return (
    <>
      <section id="sec-why  " style={{marginTop:"50px"}}>
        <div className="container brand-cont">
          <div className="row ">
            <div className="col-lg-6 offset-lg-3">
              <h2 className="text-center Layout-Title">WHY ASIA PART SOUQ</h2>
              <p className="text-center mb-5">
                From its medieval origins to the digital era, learn everything
                there is to know about the ubiquitous lorem ipsum passage.
              </p>
            </div>
          </div>
          <div className="row About-row">
            <div className="col-lg-4">
              <div className="why-div">
                <img src={"images/why1.svg"} />
                <h6 className="About-h6">Original Products</h6>
                <p>
                  When it comes to vehicle maintenance and repair, the quality
                  of a part is everything. Our Original Products guarantee that
                  you are purchasing parts that are manufactured to the exact
                  specifications and quality standards of the original equipment
                  manufacturer (OEM)
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="why-div">
                <img src={"images/why2.svg"} />
                <h6 className="About-h6">Affordable Rates</h6>
                <p className="About-p">
                  Obtaining high-quality, genuine parts shouldn't break the
                  bank. At Asia Part Souq, we leverage our strong relationships
                  with manufacturers and suppliers to secure the best possible
                  pricing.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="why-div">
                <img src={"images/why3.svg"} />
                <h6 className="About-h6">Wide variety</h6>
                <p className="About-p">
                  Our website is designed with you in mind. With intuitive
                  search functionality, detailed product information, and a
                  secure checkout process, finding and buying the right parts
                  has never been easier. We've optimized every step to save you
                  time and provide complete confidence in your purchase.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <div className="d-flex justify-content-center align-items-center">
        <section id="sec-blog" style={{ marginTop: "-50px" }}>
          <div className="container">
            <h2 className="mb-md-5 Layout-Title NewsTitle">NEWS & EVENTS</h2>
            <div className="row">
              <div className="col-lg-4">
                <div className="blog-div">
                  <div className="blog-img">
                    <img src={"images/Other/other-blog1.jpg"} />
                    <span className="date">Sep 21, 2022</span>
                  </div>
                  <h6 className="About-h6">
                    TEarth-Based 3D-Printed Homes—No Concrete Required
                  </h6>
                  <p className="About-p">
                    Japanese firm Lib Work has unveiled a groundbreaking
                    1,000-square-foot home made entirely from local soil,
                    without any concrete. Dubbed the Lib Earth House Model B,
                    this structure is reportedly five times stronger than the
                    earlier prototype.
                  </p>
                  
                </div>
              </div>
              <div className="col-lg-4">
                <div className="blog-div">
                  <div className="blog-img">
                    <img src="images/blog2.png" />
                    <span className="date">Sep 21, 2022</span>
                  </div>
                  <h6 className="About-h6">
                    Superwood—Lightweight, Fire-Resistant, Steel-Strong Wood
                  </h6>
                  <p className="About-p">
                    InventWood, a startup based in Maryland, is kicking off
                    industrial-scale production of “Superwood”—an engineered
                    timber that is stronger than steel yet six times lighter.
                  </p>
                  
                </div>
              </div>
              <div className="col-lg-4">
                <div className="blog-div">
                  <div className="blog-img">
                    <img src={"images/Other/other-blog3.jpg"} />
                    <span className="date">Sep 21, 2022</span>
                  </div>
                  <h6 className="About-h6">
                    Timber Innovation Hub Revolutionizing Sustainable
                    Architecture
                  </h6>
                  <p className="About-p">
                    The Anthony Timberlands Center for Design and Materials
                    Innovation at the University of Arkansas—a new six-storey
                    building by Grafton Architects with Modus Studio—is
                    pioneering a timber-first approach in architecture and
                    education.
                  </p>
                  
                </div>
              </div>
            </div>
          </div>
        </section>
      </div> */}
    </>
  );
};
